import { DAY_ORDER, type DayKey } from '../constants/weekDayConstants';

// The days in Monday-first order, whatever order they arrived in.
export const sortDays = (days: readonly DayKey[]): DayKey[] =>
  DAY_ORDER.filter((day) => days.includes(day));

// `days` with `day` switched: added when absent, removed when present.
export const withDayToggled = (days: readonly DayKey[], day: DayKey): DayKey[] =>
  sortDays(days.includes(day) ? days.filter((other) => other !== day) : [...days, day]);

// Whether both hold the same days, regardless of order.
export const hasSameDays = (a: readonly DayKey[], b: readonly DayKey[]): boolean =>
  a.length === b.length && a.every((day) => b.includes(day));
